// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608070004/js/" + chunkId + "." + {"44":"b3a6ac70","225":"a4970bee","481":"93c7e33d","486":"371a6c32","770":"55fc7b40"}[chunkId] + ".0.7938244439505866.chunk.js";
};